import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAnchoringdownFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.116 12.424a1.25 1.25 0 0 1 1.768 1.768l-6 6a1.25 1.25 0 0 1-1.768 0l-6-6a1.251 1.251 0 0 1 1.768-1.768L12 17.54zm0-8.808a1.25 1.25 0 1 1 1.768 1.768l-6 6a1.25 1.25 0 0 1-1.768 0l-6-6a1.25 1.25 0 1 1 1.768-1.768L12 8.732z"
  }));
}
var IcAnchoringdownFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAnchoringdownFill));

export { IcAnchoringdownFill as I };
